import { render, staticRenderFns } from "./AppDataTable.vue?vue&type=template&id=554f2e67&scoped=true&"
import script from "./AppDataTable.vue?vue&type=script&lang=js&"
export * from "./AppDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f2e67",
  null
  
)

export default component.exports